import { DiffSyncSchema } from "@megaron/diff-sync-contracts";

import { unitTemplateSerializer } from "./unitTemplate";

export const shippingDiffSyncSchema = DiffSyncSchema({
  sheetsUnitTemplate: unitTemplateSerializer,
});

export type ShippingDiffSyncChannel = keyof typeof shippingDiffSyncSchema & string;
